{
  "seat": {
    "nav": "ワークベンチ",
    "title": "Kinio Station ワークベンチ",
    "subtitle": "読み取り専用：dev plane のリースセンターと各ステーションの報告から表示します。ツールの実行や DUT のリースは kst を使ってください。",
    "not_found": "ページが見つかりません",
    "plane_down": "dev plane に接続できません（{{code}}）。ワークベンチの情報を取得できません。特定のステーションを確認するには、そのステーション上でローカルのワークベンチページ {{url}} を開いてください。",
    "loading": "読み込み中…",
    "view_stations": "ステーション別",
    "view_resources": "リソース別",
    "col_station": "ステーション",
    "col_model": "機種",
    "col_version": "tools バージョン",
    "col_online": "接続",
    "col_mode": "モード",
    "col_resources": "リソース（使用中 / 全体）",
    "col_running": "実行中",
    "col_leases": "リース",
    "online": "オンライン",
    "offline": "オフライン",
    "last_seen": "最終接続 {{ago}} 前",
    "mode_seat": "ワークベンチモード",
    "mode_full": "フル",
    "prob_offline": "オフライン",
    "prob_duplicate": "リソース ID 重複",
    "prob_tools_down": "tools デーモン停止中",
    "running_item": "{{tool}}（{{caller}}、{{ago}}）",
    "lease_item": "{{name}}：{{holder}}（{{purpose}}、{{until}} まで）",
    "col_dut": "DUT",
    "col_type": "種類",
    "col_state": "状態",
    "col_holder": "利用者",
    "col_purpose": "用途",
    "col_expires": "期限",
    "state_free": "空き",
    "state_busy": "使用中",
    "state_offline": "オフライン",
    "dup_hint": "赤い DUT は複数のステーションから報告されています。リースセンターはこの DUT のリースを発行しません。いずれかのステーションの登録を変更してください。",
    "leases_err": "リースセンターを読み込めません（{{code}}）。リース欄には各ステーションが報告した概要を表示しています（最大 30 秒遅れることがあります）。",
    "empty": "—",
    "back": "← ワークベンチ一覧",
    "detail_info": "ステーション情報",
    "hostname": "ホスト名",
    "lan": "LAN アドレス",
    "modules": "モジュール",
    "ui_home": "ローカルのホーム画面",
    "detail_resources": "リソース",
    "detail_tools": "ツール（一覧のみ、ここでは実行しません）",
    "col_tool": "ツール",
    "col_tier": "レベル",
    "col_summary": "説明",
    "tools_err": "ツール一覧を読み込めません（{{code}}）",
    "detail_runs": "最近の実行",
    "col_caller": "実行者",
    "col_started": "開始",
    "col_ended": "終了",
    "show_output": "出力を表示",
    "hide_output": "閉じる",
    "output_empty": "（出力なし）",
    "output_truncated": "（先頭 256 KB のみ表示）",
    "output_err": "出力を読み込めません（{{code}}）",
    "runs_err": "最近の実行を読み込めません（{{code}}）",
    "screenshot": "リモートスクリーンショット",
    "screenshot_busy": "スクリーンショット取得中…",
    "screenshot_err": "スクリーンショットに失敗しました（{{code}}）",
    "screenshot_err_UI_NOT_RUNNING": "ステーションの画面が開いていないため（nvr-ui が停止中）、スクリーンショットを取得できません。",
    "kst_hint": "このステーションを操作するには：kst show {{name}}",
    "station_missing": "このステーションは表示できる範囲にありません。",
    "run_running": "実行中",
    "run_succeeded": "成功",
    "run_failed": "失敗",
    "run_cancelled": "キャンセル済み",
    "run_timeout": "タイムアウト",
    "screenshot_err_SCREEN_TOO_LARGE": "画面が大きすぎるため（8 MB 超）、取得しません。"
  }
}
